import useAuth from '@sdk/authentication/useAuth';
import gettext from '@sdk/lang/gettext';

import ActivityLogAnnouncementSvg from '@web/assets/svg/images/activity-log-announcement.svg';
import { useActivityLogAnnouncement } from '@web/shifts/ActivityLog/ActivityLogAnnouncement/activityLogAnnouncement.hooks';
import FeatureAnnouncementModal from '@web/components/FeatureAnnouncementModal/FeatureAnnouncementModal';

type Props = {
  onTryNowClicked: () => void;
};

export const ActivityLogAnnouncement = ({ onTryNowClicked }: Props) => {
  const { currentUser } = useAuth();
  const { dismiss, isVisible, shouldBeShown } = useActivityLogAnnouncement();

  if (!currentUser || !shouldBeShown) {
    return null;
  }

  return (
    <FeatureAnnouncementModal
      image={<ActivityLogAnnouncementSvg />}
      isVisible={isVisible}
      dismiss={dismiss}
      title={gettext(
        'Psst! Keep track of changes to the schedule more easily with the Activity Log feature!'
      )}
      description={gettext(
        'You can now track changes made to the schedule over time in the Activity Log. View details of changes made by you or other managers, and never miss a beat.'
      )}
      buttonText={gettext('Try now')}
      onButtonClick={() => {
        onTryNowClicked();
        dismiss();
      }}
    />
  );
};
